import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  token: z.string().optional()
});

export const Route = createFileRoute("/join")({
  validateSearch: (search) => searchSchema.parse(search)
});
